'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new bind object.
 * @param {HTMLElement} element - HTML element to bind with a class.
 */
exports.default = function (element, config) {

  /**
   * Instance defaults settings.
   */
  var defaults = {
    className: 'post-init'
  };

  /**
   * Instance settings.
   */
  var settings = (0, _utils.extendDefaults)(defaults, config);

  /**
   * Set bind class on target.
   */
  function set() {
    if (!element.length) {
      element.classList.add(settings.className);
      return;
    }

    [].concat((0, _toConsumableArray3.default)(element)).forEach(function (item) {
      item.classList.add(settings.className);
    });
  }

  /**
   * Remove bind class on target.
   */
  function remove() {
    if (!element.length) {
      element.classList.remove(settings.className);
      return;
    }

    [].concat((0, _toConsumableArray3.default)(element)).forEach(function (item) {
      item.classList.remove(settings.className);
    });
  }

  /**
   * Check if element has already been initialised.
   */
  function isSet() {
    if (!element.length) {
      return element.classList.contains(settings.className);
    }

    return [].concat((0, _toConsumableArray3.default)(element)).every(function (item) {
      return item.classList.contains(settings.className);
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    isSet: isSet,
    remove: remove,
    set: set
  });
}; /**
    * Mixin: Bind
    * -----------------------------------------------------------------------------
    * Mixin to set, remove and detect a class from a defined target.
    * - Useful to avoid multiple event binds when initialising components.
    *
    */